import { IconBuildingCommunity } from '@tabler/icons-react';
import { COMPONENT_PROJECT_SELECT_OPTIONS } from '../dashboard/admin/AdminComponentProjectMetrics';
import { useAdminComponentProjectFilterStore } from '../../stores/adminComponentProjectFilterStore';
import { NavbarCompactSelect } from '../layout/NavbarCompactSelect';

export function NavbarComponentProjectSelector() {
  const componentProject = useAdminComponentProjectFilterStore((s) => s.componentProject);
  const setComponentProject = useAdminComponentProjectFilterStore((s) => s.setComponentProject);

  return (
    <NavbarCompactSelect
      icon={<IconBuildingCommunity size={16} aria-hidden />}
      ariaLabel="Component project"
      placeholder="All projects"
      data={COMPONENT_PROJECT_SELECT_OPTIONS}
      value={componentProject}
      onChange={setComponentProject}
      clearable
    />
  );
}
